module.exports = __webpack_public_path__ + "static/media/ss5.c0bf6f7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/ss5.png
// module id = 232
// module chunks = 0